<template>
  <footer class="w-full bg-neutral-950 relative z-[2]">
    <div class="py-10 bg-neutral-950 text-white relative lg:py-20 px-4 lg:px-0">
      <img
        src="~/assets/images/footer-diagonals.svg"
        alt=""
        class="absolute bottom-0 right-0 z-[1] h-full object-cover"
      />
      <ContainerBasic
        class="flex flex-col lg:flex-row lg:justify-between gap-8 relative z-[2]"
      >
        <div class="flex flex-col gap-8 lg:gap-20 lg:grow lg:max-w-[960px]">
          <img
            class="w-auto max-w-[180px] lg:max-w-[320px]"
            src="/assets/images/logo-red-white.svg"
          />
          <div class="flex flex-col md:flex-row w-full gap-5">
            <div class="lg:grow">
              <p class="mb-3 lg:mb-6 font-bold">Portal</p>
              <ul class="text-sm text-neutral-300 flex flex-col gap-1 lg:gap-2">
                <li>
                  <NuxtLink :to="{ path: '/rankings/portal/teams' }">
                    Team Rankings
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/rankings/portal/players' }">
                    Player Rankings
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div class="lg:grow">
              <p class="mb-3 lg:mb-6 font-bold">Rankings</p>
              <ul class="text-sm text-neutral-300 flex flex-col gap-1 lg:gap-2">
                <li>
                  <NuxtLink :to="{ path: '/rankings/teams' }">Teams</NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/rankings/teams/hitting' }">
                    Team Hitting
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/rankings/teams/pitching' }">
                    Team Pitching
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/rankings/player/hitting' }">
                    Player Hitting
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/rankings/player/pitching' }">
                    Player Pitching
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div class="lg:grow">
              <p class="mb-3 lg:mb-6 font-bold">About 64</p>
              <ul class="text-sm text-neutral-300 flex flex-col gap-1 lg:gap-2">
                <li>
                  <NuxtLink :to="{ path: '/articles' }">Blog</NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/about-64' }">About Us</NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/privacy-policy' }">
                    Privacy Policy
                  </NuxtLink>
                </li>
                <li>
                  <NuxtLink :to="{ path: '/terms-of-service' }">
                    Terms of Service
                  </NuxtLink>
                </li>
              </ul>
            </div>
            <div class="col flex flex-col gap-3">
              <NuxtLink :to="{ path: '/teams' }">Teams</NuxtLink>
              <NuxtLink :to="{ path: '/players' }">Players</NuxtLink>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-8">
          <div class="lg:pt-8">
            <p class="font-bold">Need help with something?</p>
            <p class="text-sm mb-5 opacity-90">
              Our support team is waiting to help.
            </p>
            <a
              href="#"
              @click.prevent="
                openIntercom(
                  'I need assistance on 64 analytics with the following: '
                )
              "
              class="underline opacity-90"
              >Contact Support</a
            >
            <p class="mb-5 mt-[80px] lg:mt-[200px]">
              Follow us on social media:
            </p>
            <ul
              class="socials-list text-white text-2xl flex gap-5 items-center"
            >
              <li>
                <a
                  href="https://www.twitter.com/@64analytics"
                  target="_blank"
                  class="block group hover:text-black transition-colors"
                >
                  <i class="fab fa-twitter"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/channel/UCkFHMVwOiZPTD-2WucxLo3Q"
                  target="_blank"
                  class="block group hover:text-black transition-colors"
                >
                  <i class="fab fa-youtube"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/64analytics/"
                  target="_blank"
                  class="block group hover:text-black transition-colors"
                >
                  <i class="fab fa-instagram"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </ContainerBasic>
    </div>
    <div class="bg-black h-[100px] flex items-center justify-center">
      <p class="text-sm text-gray-700 text-center">
        &copy;Sixty Four Analytics {{ new Date().getFullYear() }}
      </p>
    </div>
  </footer>
</template>

<script lang="ts" setup>
const { openIntercom } = useIntercom();
</script>
